export interface NextTaskScheduler {
    cancel: () => void;
    schedule: () => void;
}

export function createNextTaskScheduler(task: () => void): NextTaskScheduler {
    let timerId: ReturnType<typeof setTimeout> | null = null;

    function runTask(): void {
        timerId = null;
        task();
    }

    return {
        schedule(): void {
            if (timerId !== null) return;

            // Yield one task so same-turn subscription churn collapses into one transport reconcile.
            timerId = setTimeout(runTask, 0);
        },
        cancel(): void {
            if (timerId === null) return;

            clearTimeout(timerId);
            timerId = null;
        },
    };
}
